import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=8f5b2a18&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=8f5b2a18&prod&lang=scss&"
import style1 from "./Carousel.vue?vue&type=style&index=1&id=8f5b2a18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports